import { NzSelectModule } from 'ng-zorro-antd/select';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { DisplayPipesModule } from 'src/app/pipes/display/display-pipes.module';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { QueryPipesModule } from 'src/app/pipes/query/query-pipes.module';
import { NzImageModule } from 'ng-zorro-antd/image';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzCarouselModule } from 'ng-zorro-antd/carousel'
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzInputModule } from 'ng-zorro-antd/input';
import { FormsModule } from '@angular/forms';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { ConvertModule } from 'src/app/pipes/convert/convert.module';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { DxDataGridModule, DxGanttModule, DxPopoverModule } from 'devextreme-angular';
import { NzAffixModule } from 'ng-zorro-antd/affix';
import { NzSegmentedModule } from 'ng-zorro-antd/segmented';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzNotificationModule } from 'ng-zorro-antd/notification';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzLayoutModule } from 'ng-zorro-antd/layout';

@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    NzButtonModule,
    DisplayPipesModule,
    NzGridModule,
    QueryPipesModule,
    NzImageModule,
    NzIconModule,
    NzCarouselModule,
    NzTagModule,
    NzDropDownModule,
    NzModalModule,
    NzInputModule,
    FormsModule,
    NzDividerModule,
    NzInputNumberModule,
    QueryPipesModule,
    ConvertModule,
    NzInputModule,
    NzTableModule,
    NzToolTipModule,
    DxDataGridModule,
    NzSelectModule,
    NzAffixModule,
    NzSegmentedModule,
    NzDatePickerModule,
    NzNotificationModule,
    NzPopconfirmModule,
    NzPopoverModule,
    DxPopoverModule,
    NzSwitchModule,
    NzSpinModule,
    NzLayoutModule,
    DxGanttModule
  ],
  exports: [
  ]
})
export class WidgetsModule { }
